/**
 * The initials of a client or a sender in the Bureau (PLAN-BUREAU), on Encre's grey disc. Pure
 * presentation — nothing is matched or linked on the name (principle 12): it only paints letters.
 */

/** Words that say nothing about who the client is: articles and the « Groupe » of a group. */
const FILLER = new Set(['le', 'la', 'les', 'l', 'du', 'de', 'des', 'd', 'groupe', 'the']);

/** One letter, or two when the name is two distinctive words (« Voyages du Bas Quercy » → VB). */
export function initialsOf(name: string | null | undefined): string {
  const words = (name ?? '')
    .normalize('NFC')
    .split(/[\s'’\-–—_.,/]+/)
    .map((w) => w.trim())
    .filter((w) => w && !FILLER.has(w.toLowerCase()));
  if (words.length === 0) return '?';
  const first = words[0];
  const letter = (w: string) => Array.from(w)[0]?.toUpperCase() ?? '';
  // A leading generic word followed by the real name reads as two letters, like the mock-up.
  if (words.length >= 3) return `${letter(first)}${letter(words[1])}`;
  return letter(first);
}
